import { Controller } from "@hotwired/stimulus"
import { showNotification } from "../helpers"

export default class extends Controller {
  static targets = ["elemToCopy"]

  copy() {
    let text = ""
    if (this.hasElemToCopyTarget) {
      text = this.elemToCopyTarget.value || this.elemToCopyTarget.innerText || this.elemToCopyTarget.textContent
    } else {
      const el = this.element
      text = el.dataset.clipboardText || el.innerText || el.value
    }

    if (!text) return

    navigator.clipboard.writeText(text.trim())
      .then(() => {
        if (this.element.dataset.clipboardSuccessMessage) {
          showNotification(this.element.dataset.clipboardSuccessMessage)
        } else {
          showNotification("Skopiowano do schowka")
        }
        this.dispatch("copied")
      })
      .catch((error) => {
        showNotification("Nie udało się skopiować")
        console.log(error)
      })
  }
}
